import React from 'react';
import { FaFacebook, FaInstagram, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[#1c1a24] text-white p-4">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
        {/* Footer Text */}
        <div className="text-center md:text-left">
          <p>Society of Young Engineers</p>
          <p>Toward Achieving Excellence</p>
        </div>

        {/* Social Media Icons */}
        <div className="flex space-x-4 mt-4 md:mt-0">
          <a href="https://www.facebook.com/DLSU.SYNTAX" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400">
            <FaFacebook className="h-6 w-6" />
          </a>
          <a href="https://www.instagram.com/dlsu.syntax/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400">
            <FaInstagram className="h-6 w-6" />
          </a>
          <a href="mailto:syntax@dlsu.edu.ph" className="hover:text-gray-400">
            <FaEnvelope className="h-6 w-6" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
